var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_2209_1731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.83 10.7778C9.333 10.1222 8.53 9.44444 8.53 8.38889C8.53 7.17778 9.641 6.33333 11.5 6.33333C13.062 6.33333 13.843 6.93333 14.129 7.88889C14.261 8.33333 14.624 8.66667 15.086 8.66667H15.416C16.142 8.66667 16.659 7.94444 16.406 7.25556C15.944 5.94444 14.866 4.85556 13.15 4.43333V3.66667C13.15 2.74444 12.413 2 11.5 2C10.587 2 9.85 2.74444 9.85 3.66667V4.4C7.716 4.86667 6 6.26667 6 8.41111C6 10.9778 8.101 12.2556 11.17 13C13.92 13.6667 14.47 14.6444 14.47 15.6778C14.47 16.4444 13.931 17.6667 11.5 17.6667C9.685 17.6667 8.75 17.0111 8.387 16.0778C8.222 15.6444 7.848 15.3333 7.397 15.3333H7.089C6.352 15.3333 5.835 16.0889 6.11 16.7778C6.737 18.3222 8.2 19.2333 9.85 19.5889V20.3333C9.85 21.2556 10.587 22 11.5 22C12.413 22 13.15 21.2556 13.15 20.3333V19.6111C15.295 19.2 17 17.9444 17 15.6667C17 12.5111 14.327 11.4333 11.83 10.7778Z",
    fill: "#A3AED0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2209_1731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.7758d11ba19e5c8b97a577751539303b.svg";
export { ForwardRef as ReactComponent };